import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDDialogContent,
  FDPaper,
  FDStack, FDIcon,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { pillarToOutlinedIcon } from 'Consts/pillars';
import { ModalActions } from 'Views/Page/Content/Modal/Layouts/MemberActionItem/Layout/ModalActions';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <>
      <FDDialogContent>
        <FDStack direction={'column'} spacing={2} padding={3}>
          <FDStack direction={'column'} justifyContent={'flex-start'} spacing={1}>
            <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={4}>
              <MetaControlField attr={'pillar'} />
              <FDIcon icon={pillarToOutlinedIcon[resource.attr('pillar')]} size={'lg'} />
            </FDStack>

            <MetaControlField attr={'name'} />
          </FDStack>
          <MetaControlField attr={'description'} />
          {(resource.attr('directions') || resource.attr('dueDateSummaryString')) ? (
            <FDPaper appearance="flat" color="subtle" padding={2}>
              <FDStack direction={'column'} spacing={1}>
                <MetaControlField attr={'directions'} />
                <MetaControlField attr={'dueDateSummaryString'} />
              </FDStack>
            </FDPaper>
          ) : null}
        </FDStack>
      </FDDialogContent>
      <ModalActions />
    </>
  );
};

export default Layout;
